// extracted by mini-css-extract-plugin
export default {"wrapper":"Pz-z","button":"Qz-z","alternate":"Rz-z","disabled":"Sz-z","paymentWarning":"Tz-z","fadeIn":"Uz-z"};